import user from '@/api/user'
import privilege from '@/api/privilege'
import { getToken, setToken, removeToken } from '@/utils/auth'
import { resetRouter } from '@/router'
import ests from 'ests-sdk-web'

const state = {
  token: getToken(),
  name: '',
  avatar: '',
  currentUser: {},
  tenantId: '',
  menus: [],
  currentTenantName: '',
  currentTenantType: ''
}

const mutations = {
  SET_TOKEN: (state, token) => {
    state.token = token
  },
  SET_MENUS: (state, menus) => {
    state.menus = menus
  },
  SET_NAME: (state, name) => {
    state.name = name
  },
  SET_AVATAR: (state, avatar) => {
    state.avatar = avatar
  },
  SET_CURRENT_USER: (state, currentUser) => {
    state.currentUser = currentUser
  },
  SET_TENANT_ID: (state, tenantId) => {
    state.tenantId = tenantId
  },
  SET_TENANT_NAME: (state, tenantName) => {
    state.currentTenantName = tenantName
  },
  SET_TENANT_TYPE: (state, tenantType) => {
    state.currentTenantType = tenantType
  }

}

const actions = {
  // user login
  login({ commit }, userInfo) {
    const { username, password, captcha, captchaVersion } = userInfo
    return new Promise((resolve, reject) => {
      user.signIn({ username: username.trim(), password: password, captcha: captcha, captchaVersion: captchaVersion }).then(response => {
        const { data } = response
        commit('SET_TOKEN', data)
        setToken(data)
        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  },

  setStoreToken({ commit }, token) {
    commit('SET_TOKEN', token)
  },

  // get user info
  getInfo({ commit, state }) {
    return new Promise((resolve, reject) => {
      user.getInfo().then(response => {
        const { data } = response
        ests.setUserInfo({
          guid: data.id
        })
        if (!data) {
          reject('Verification failed, please Login again.')
        }
        const { name, avatar } = data

        // commit('SET_TENANT_ID', data.tenantId)
        commit('SET_NAME', name)
        commit('SET_CURRENT_USER', data)
        commit('SET_AVATAR', avatar)
        resolve(data)
      }).catch(error => {
        reject(error)
      })
    })
  },

  // get user info
  getMenus({ commit, state }) {
    return new Promise((resolve, reject) => {
      privilege.menu.listRole().then(res => {
        const data = res.data
        if (!data) {
          reject('菜单获取失败，请重新登录！')
        } else {
          resolve(data)
        }
      }).catch(error => {
        reject(error)
      })
    })
  },

  // user logout
  logout({ commit, state }) {
    return new Promise((resolve, reject) => {
      commit('SET_TOKEN', '')
      commit('SET_NAME', '')
      commit('SET_TENANT_ID', '')
      commit('SET_CURRENT_USER', '')
      removeToken()
      resetRouter()
      resolve()
    })
  },

  // remove token
  resetToken({ commit }) {
    return new Promise(resolve => {
      commit('SET_TOKEN', '')
      removeToken()
      resolve()
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}

